import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app';

window.aiderWebApp = window.aiderWebApp || {};
window.aiderWebApp.config = window.aiderWebApp.config || {};
ReactDOM.render(<App appConfig={window.aiderWebApp.config} />, document.getElementById('aider-web-app-root'));
